export default function FinalCTA() {
  const scrollToConsultation = () => {
    const element = document.getElementById('consultation');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-32 px-6 bg-gradient-to-br from-[#E3F2FD] to-[#BBDEFB]">
      <div className="max-w-4xl mx-auto">
        <div className="text-[#1A2B4A] mb-12 text-center">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6 leading-tight text-red-600">
            修行は「感覚」ではなく<br />
            数字管理が勝ち！！
          </h2>
          <p className="text-base leading-relaxed text-[#5A5A5A] mb-3">
            修行は一度きり。後戻りはできません。
          </p>
          <p className="text-base leading-relaxed text-[#5A5A5A]">
            合理的な設計で、確実にゴールへ。
          </p>
        </div>
      </div>
    </section>
  );
}
